import React, { useState, useEffect, useRef } from 'react';
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { FaLink, FaImage, FaRegFilePdf, FaVideo, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Metatag from "../../hooks/Metatag";
import { HashLink } from "react-router-hash-link";

export default function Sitemap() {

  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();


  }, []);

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -134;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  }

  const [peopleCategory, setPeopleCategoryList] = useState([]);

  const [newsTypeList, setNewsTypeList] = useState([]);

  const [researchTypeList, setResearchTypeList] = useState([]);

  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    let _obj = new Object();
    _obj.pcategory_status = 1;
    // setTimeout(() => {

    axios.post(global.variables.strApiUrl + "/peoplecategoryApi/getcategoryHavingPeopleList", _obj)
      .then((response_list) => {
        if (response_list.data === 'error') {
          navigate('/error-page')
        }
        else {
          // pass the result in the success function of the respective page
          setPeopleCategoryList(response_list.data[0]);
        }
      });

      axios.post(global.variables.strApiUrl + "/researchApi/getResearchTypeHavingResearch", new Object())
        .then((response_list) => {
            // pass the result in the success function of the respective page
            setResearchTypeList(response_list.data[0]);
        });

    // }, 300);

    // axios.post(global.variables.strApiUrl + "/newstypeApi/getcategoryHavingNewsList")
    //     .then((response_list) => {
    //         // pass the result in the success function of the respective page
    //         setNewsTypeList(response_list.data[0]);
    //     });

  }, [])

  return (
    <>
      <Header></Header>
      <Metatag title='Research and Development Programs for Green Energy, Environment and Sustainability' keywords='Research Programs for Green Energy by IIT Bombay, Research Programs for Green Hydrogen by IIT Bombay, Research Programs for Battery Technologies by IIT Bombay, Research Programs for Bio Fuels by IIT Bombay, Research Programs for Sustainability by IIT Bombay, IIT Bombay Research Hub for Green Energy, IIT Bombay Research Hub for Sustainability' description='Research Programs for Green Energy, Battery Technologies, Bio Fuels and Other Green Energy Sustainability Programs offered by IIT Bombay Research Hub' />

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
              <div className="visual-inside-big visual-container-inside">
                <Container >
                  <Row className="g-md-0">
                    <Col md={12} className="">
                      <div className="py-md-4">
                        <div className="m-0 text-center py-xl-3 p-2 text-white">
                          <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                            Sitemap
                          </h1>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Container>
      
      


      {/* Container */}
      <Container className="my-5 pt-4 pt-xl-5 list">
        <Row className="row-cols-1 row-cols-md-2  row-cols-lg-4 row-cols-xl-5 g-md-5 g-3">
          <Col>
            <ul className='m-0'>
              <li><Link to={global.variables.strDomainUrl}>Home</Link></li>
              <li><Link to={'/news'}>News</Link></li>
              <li><Link to={'/events'}>Events</Link></li>
              <li><Link to={'/knowledge-hub'}>Knowledge Hub</Link></li>
              <li><Link to={global.variables.strDomainUrl + "careers"}>Careers</Link></li>
            </ul>
            </Col>
          <Col>
            <b>About</b>
            <ul className='m-0'>
              <li><Link to={"/aboutus"}>About GESH IITB</Link></li>
              <li><b>People</b>
                <ul className='m-0'>
                  {
                    peopleCategory.map((val) => {
                      return (

                        <li><Link to={global.variables.strDomainUrl + 'people/' + val.pcategory_pagename}>{val.pcategory_name}</Link></li>
                      )
                    })
                  }
                </ul>
              </li>
            </ul>
          </Col>
          <Col>
            <b>Education</b>
            <ul className='m-0'>
              <li><Link to={"/education"}>Overview</Link></li>
              <li><HashLink to="/education/#IITBCourses" onClick={() => setExpanded(false)} scroll={el => scrollWithOffset(el)}>IITB Courses</HashLink></li>
              <li><HashLink to="/education/#IndustryTrainingPrograms" onClick={() => setExpanded(false)} scroll={el => scrollWithOffset(el)}>Industry Training Programs</HashLink></li>
              <li><HashLink to="/education/#EPGD" onClick={() => setExpanded(false)} scroll={el => scrollWithOffset(el)}>EPGD</HashLink></li>
              <li><HashLink to="/education/#Online_Courses" onClick={() => setExpanded(false)} scroll={el => scrollWithOffset(el)}>Online Courses</HashLink></li>
            </ul>
          </Col>
          <Col>
            <b>Research</b>
            <ul className='m-0'>
              <li><Link to="/research">Overview</Link></li>
              <li><Link to="/focus-areas">Focus Areas</Link></li>
              {
                researchTypeList.map((val) => {
                  return (
                    <li><Link to={global.variables.strDomainUrl + 'research-projects/' + val.rtype_pagename}>{val.rtype_name}</Link></li>
                  )
                })
              }

              <li><Link to="/publications">Publications</Link></li>
            </ul>
          </Col>
          <Col>
            <b>Campus Sustainability</b>
            <ul>
              <li><Link to="/campus-sustainability">Sustainability @ IITB</Link></li>
              <li><Link to="/campus-sustainability/gesh-iitb-living-lab-program">GESH IITB Living Lab Program</Link></li>
              {/* <li><Link to="">Policies</Link></li> */}
            </ul>
            <b>Outreach</b>
            <ul>
              <li><Link to="/partners">Partnerships</Link></li>
              <li><Link to="/events">Events</Link></li>
            </ul>
          </Col>
        </Row>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Site Map</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}